import {gql} from '@apollo/client';

export const reminderQueries = {
    ONE_REMINDER: gql`
        query GetOneReminder($where: ReminderModelFilterInput) {
            oneReminder(where: $where) {
                id
                title
                description
                reminderDate
                status
                objectId
                objectType
                type
                userId
            }
        }
    `,
    GET_REMINDERS: gql`
        query GetReminders(
            $where: ReminderModelFilterInput
            $after: String
            $order: [ReminderModelSortInput!]
            $first: Int
            $before: String
            $last: Int
        ) {
            reminders(where: $where, order: $order, after: $after, first: $first, before: $before, last: $last) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    description
                    id
                    objectId
                    objectType
                    reminderDate
                    status
                    title
                    type
                    userId
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    `,

    REMINDERS_COUNT: gql`
        query reminderCount($where: ReminderModelFilterInput) {
            reminders(where: $where) {
                totalCount
            }
        }
    `,
};
